import TradeAPAddToPortfolio from './TradeAPAddToPortfolio';

export default TradeAPAddToPortfolio;
